import { History, LayoutDashboard, Phone, Settings } from "lucide-react";
import type { SidebarData } from "../types";

export const sidebarData: SidebarData = {
  navGroups: [
    {
      title: "General",
      items: [
        {
          title: "Dashboard",
          url: "/$tenantId",
          icon: LayoutDashboard,
        },
        {
          title: "Numbers",
          url: "/$tenantId/numbers",
          icon: Phone,
        },
        {
          title: "Call Logs",
          url: "/$tenantId/call-logs",
          icon: History,
        },
      ],
    },
    {
      title: "Other",
      items: [
        {
          title: "Settings",
          icon: Settings,
          url: "/$tenantId/settings",
        },
      ],
    },
  ],
};
